import * as React from 'react';
const uuid = require('react-uuid');
import { RedoOutlined } from '@ant-design/icons';
import core, { Bubble, Button, useMessages } from '@chatui/core';
const Chat = core;
import { MessageType, ExternalTryItNowClient, ActionType } from './client';
import '@chatui/core/es/styles/index.less';
import '@chatui/core/dist/index.css';
import { parseQuery } from '@lib/parse-query';
import { Spin, message } from 'antd';
import './external.less';
import { default as ReactMde } from 'react-mde';
import 'react-mde/lib/styles/css/react-mde-all.css';
import * as Showdown from 'showdown';
import { API } from '@config/api';
const converter = new Showdown.Converter({
  tables: true,
  simplifiedAutoLink: true,
  strikethrough: true,
  tasklists: true
});

const botAvatar = require('@static/image/icons/chat_bot.jpg');
const logo = require('@static/image/mini-logo.png');
const logoWithLabel = require('@static/image/logo.png');

function getAvatar(user: any) {
  return user.id === 'my_user_id' ? '//gw.alicdn.com/tfs/TB1DYHLwMHqK1RjSZFEXXcGMXXa-56-62.svg' : logo;
}

function converMessage(copilotMsg: any) {

  switch (copilotMsg.messageType) {
    case MessageType.Text:
      return {
        type: 'text',
        content: { text: copilotMsg.text },
        position: copilotMsg.user.id === 'my_user_id' ? 'right' : 'left',
        user: { avatar: getAvatar(copilotMsg.user) }
      };
    case MessageType.Card:
      return {
        type: 'card',
        content: copilotMsg,
        position: copilotMsg.user.id === 'my_user_id' ? 'right' : 'left',
        user: { avatar: getAvatar(copilotMsg.user) }
      };
    default:
      return { type: 'text' };
  }
}

let client: ExternalTryItNowClient;

function externalTryItNow(props: any) {

  // 消息列表
  const { messages, appendMsg, setTyping, resetList } = useMessages([]);
  const [botId, setBotId] = React.useState<string>('');
  const [botLabel, setBotLabel] = React.useState<string>('Chatbot');
  const [readme, setReadme] = React.useState<string>('');
  const [connecting, setConnecting] = React.useState<boolean>(false);

  const me = {
    id: uuid(),
    name: 'Casual user'
  };

  React.useEffect(() => {

    const query = parseQuery(window.location.search);
    const url = decodeURIComponent(query.bot_url);
    setBotId(query.bot_id);

    setConnecting(true);
    API.agent.getSimpleBotInfo(query.bot_id).then((agent: any) => {
      setBotLabel(agent.name);
      setReadme(agent.read_me);
    }).catch((error: any) => {
      setConnecting(false);
      message.error(error.message);
      throw error;
    });

    client = ExternalTryItNowClient.create({
      // url: 'https://api-65f115cd72f02e82bb7a74ad.api-us.naturali.io/v1/en',
      url,
      user: me
    });

    // register context getter. for example, just pass current url as app state.
    client.registerContextGetter(() => {

      return {
        url: window.location.href
      };
    });

    client.registerActionHandler((action: any) => {

      if (action.url) {
        window.location.href = action.url;
      } else {
        alert(JSON.stringify(action, undefined, 4));
      }
    });

    client.connect().then((initMsgs: any) => {
      setConnecting(false);
      for (const msg of initMsgs) {
        appendMsg(converMessage(msg) as any);
      }
    }).catch((err: any) => {
      setConnecting(false);
      message.warning(err.message);
      setTyping(false);
    });

  }, []);

  function handleSend(type: any, val: any, extra: any) {
    if (type === 'text' && val.trim()) {

      appendMsg({
        type: 'text',
        content: { text: val },
        position: 'right',
        // user: {
        //   avatar: '//gw.alicdn.com/tfs/TB1DYHLwMHqK1RjSZFEXXcGMXXa-56-62.svg'
        // }
      });

      setTyping(true);

      client.sendMessage({
        messageType: MessageType.Text,
        text: val,
        user: me
      }, false, extra).then((resps: any) => {
        for (const msg of resps) {
          appendMsg(converMessage(msg) as any);
        }
      }).catch((err: any) => {
        message.warning(err.message);
        setTyping(false);
      });
    }
  }

  function handleQuickReplyClick(text: any, extra: any) {
    handleSend('text', text, extra);
  }

  function renderMessageContent(msg: any) {
    const { type, content } = msg;

    const media = content.richMedia;

    switch (type) {
      case 'text':
        return <Bubble content={content.text} style={{ textAlign: 'left' }} />;
      case 'image':
        return (
          <Bubble type="image">
            <img src={content.picUrl} alt="" />
          </Bubble>
        );
      case 'card':
        return (
          <Bubble type="card" content={<div style={{ padding: '0 8px' }}>
            {
              content.title && <h3 key="title" style={{
                textAlign: 'left',
                margin: 4
              }}>{content.title}</h3>
            }
            {
              content.text && <pre key="text" style={{
                margin: 4,
                textAlign: 'left',
                width: '100%',
                whiteSpace: 'pre-wrap',
                wordBreak: 'normal',
                overflowWrap: 'anywhere'
              }}>{content.text}</pre>
            }

            {media && <img key="img" style={{ maxWidth: '100%' }} src={media.fileURL} alt={media.altText} />}
            {content.actionList && content.actionList.length ? <div style={{ display: 'flex', flexWrap: 'wrap', marginLeft: -4, marginRight: -4 }}>
              {
                content.actionList.map((action: any, index: any) => {
                  return <Button key={index} onClick={() => {
                    switch (action.actionType) {

                      case ActionType.reply:
                        handleQuickReplyClick(action.text, action.actionParams);
                        break;
                      case ActionType.click:
                        client.executeAction(action);
                        break;
                      default:
                        alert('This action is not supported yet');
                        break;
                    }
                  }} color="primary" style={{ margin: 4 }}>{action.text}</Button>;
                })
              }
            </div> : ''
            }
          </div>} />
        );
      default:
        return null;
    }
  }

  return (
    <div className="body-content">
      <Spin spinning={connecting} tip="Connecting">
        <div className="share-page-body">
          <span className="body-left hide-mde-header" >
            <h2><img src={logoWithLabel} /></h2>
            <br />
            <br />
            <h3>You've been invited to have a conversation with <a style={{ cursor: 'inherit' }}>{botLabel}</a></h3>
            <br />
            <br />
            <ReactMde
              readOnly
              value={readme}
              selectedTab={'preview'}
              generateMarkdownPreview={(markdown: string) =>
                Promise.resolve(converter.makeHtml(markdown))
              }
              childProps={{
                writeButton: {
                  tabIndex: -1
                }
              }}
            />
          </span>
          <span className="chat-container">
            <Chat
              locale="en-US"
              navbar={{
                title: botLabel,
                // rightContent: [{
                //   label: <RedoOutlined />,
                //   onClick: () => {
                //     resetList();
                //     client.connect().then((initMsgs: any) => {
                //       for (const msg of initMsgs) {
                //         appendMsg(converMessage(msg) as any);
                //       }
                //     }).catch((err: any) => {
                //       message.warning(err.message);
                //       setTyping(false);
                //     });
                //   }
                // }]
              }}
              messages={messages}
              renderMessageContent={renderMessageContent}
              onSend={handleSend}
              placeholder="Try your query"
              // rightAction={{
              //   label: <RedoOutlined />,
              //   onClick: () => {
              //     resetList();
              //     client.connect().then((initMsgs: any) => {
              //       for (const msg of initMsgs) {
              //         appendMsg(converMessage(msg) as any);
              //       }
              //     }).catch((err: any) => {
              //       message.warning(err.message);
              //       setTyping(false);
              //     });
              //   }
              // }}
              {
              ...props
              }
            />
          </span>
        </div>
      </Spin>
    </div>
  );
}

export const ExternalTryItNow = externalTryItNow;
